export const DefaultErrorMessage = "Error, please try again";
export const UpdateDataSuccessfully = "Cập nhật dữ liệu thành công";
export const QuestionRemove = "Bạn có chắc chắn muốn xóa không?";
